import { useState } from "react";
import AgentResponseLayout from "../../../components/agent/AgentResponseLayout";
import SelectInput from "../../../components/forms/SelectInput";
import MultiSelectInput from "../../../components/forms/MultiSelectInput";
import NotesField from "../../../components/forms/NotesField";
import { useAgentResponse } from "../../../js/hooks/useAgentResponse";
import { AGE_BANDS, CONDITION_OPTIONS, INSPECTION_FLAGS, UPDATE_OPTIONS } from "../../../js/utils/agentResponseOptions";

export default function AgentResponseCondition() {
  const { response, saveSection, goBack, goNext } = useAgentResponse("condition");
  const saved = response?.condition || {};
  const [form, setForm] = useState(null);
  const current = form || saved;

  function update(event) {
    const { name, value } = event.target;
    setForm((prev) => ({ ...(prev || saved), [name]: value }));
  }

  async function handleContinue() {
    await saveSection(current);
    goNext();
  }

  if (!response) {
    return (
      <AgentResponseLayout title="Condition" onBack={goBack} onContinue={() => {}}>
        <p>Loading response…</p>
      </AgentResponseLayout>
    );
  }

  return (
    <AgentResponseLayout
      response={response}
      sectionKey="condition"
      title="Condition"
      lead="Overall readiness, recent updates, system ages, and flags to watch on inspection."
      onBack={goBack}
      onContinue={handleContinue}
    >
      <section className="checklist-section">
        <h2>Overall Condition</h2>
        <SelectInput label="Condition" name="overall" value={current.overall} onChange={update} options={CONDITION_OPTIONS} />
        <MultiSelectInput label="Updates completed" name="updates" values={current.updates || []} onChange={update} options={UPDATE_OPTIONS} size={8} />
      </section>
      <section className="checklist-section">
        <h2>Ages & Inspection Flags</h2>
        <SelectInput label="Roof age" name="roofAge" value={current.roofAge} onChange={update} options={AGE_BANDS} />
        <SelectInput label="HVAC age" name="hvacAge" value={current.hvacAge} onChange={update} options={AGE_BANDS} />
        <SelectInput label="Window age" name="windowsAge" value={current.windowsAge} onChange={update} options={AGE_BANDS} />
        <MultiSelectInput
          label="Inspection flags"
          name="inspectionFlags"
          values={current.inspectionFlags || []}
          onChange={update}
          options={INSPECTION_FLAGS}
          size={8}
        />
        <NotesField
          label="Repairs needed"
          name="repairsNeeded"
          value={current.repairsNeeded}
          onChange={update}
          rows={3}
          placeholder="Visible repairs, seller credits to discuss, or work the buyer should budget."
        />
        <NotesField
          label="Condition notes"
          name="notes"
          value={current.notes}
          onChange={update}
          placeholder="Lived-in vs. staged, odors, deferred maintenance, or pride of ownership."
        />
      </section>
    </AgentResponseLayout>
  );
}
